export const MATTLE_REQUEST = "MATTLE_REQUEST";
export const MATTLE_SUCCESS = "MATTLE_SUCCESS";
export const MATTLE_FAILED = "MATTLE_FAILED";
